import * as React from 'react';
import { ReactNode } from 'react';
import '../css/key-art-poster.sass';
import '../css/expanded-poster.sass';
import StaticElementButton from './StaticElementButton';

interface ExpandedPosterProps {
  id: string;
  children: ReactNode;
  onClose?: Function;
  theme?: 'night' | 'day';
}

export default function ExpandedPoster(props: ExpandedPosterProps) {
  const { theme = 'day' } = props;
  return (
    <div
      id={`${props.id.toLowerCase()}-expanded`}
      aria-hidden="true"
      className={`poster-details ${theme}`}
    >
      <StaticElementButton
        className="close-icon"
        id={`close-poster-${props.id.toLowerCase()}`}
        name="close-poster"
        label=""
        tabIndex={-1}
        type="div"
        onClick={() => {
          if (props.onClose) props.onClose();
        }}
      />
      {props.children}
    </div>
  );
}
